import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import AdminLayout from "./layouts/main";
import LoginPage, { setUserRole } from "./LoginPage";


const App = () => {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [rolesReady, setRolesReady] = useState(false);

    useEffect(() => {
        if (!isAuthenticated) {
            const accounts = instance.getAllAccounts();
            if (accounts.length > 0) {
                instance.setActiveAccount(accounts[0]);
            }
            setRolesReady(false);
        }
    }, [instance, isAuthenticated]);

    useEffect(() => {
        if (isAuthenticated) {
            const account = instance.getAllAccounts()[0];
            setUserRole(account);
            setRolesReady(true);
        }
    }, [isAuthenticated, instance]);

    if (!isAuthenticated) {
        return <LoginPage />;
    }

    if (!rolesReady) {
        return null;
    }

    return <AdminLayout />;
};

export default App;
